import {
  MfaChallengeVerifyRequest,
  MfaFactorCreateType,
  PersonMfaFactor
} from "@wingspanhq/wingspan-api-sdk";

const TYPE_LABEL: Record<MfaFactorCreateType, string> = {
  [MfaFactorCreateType.SMS]: "Text message (SMS)",
  [MfaFactorCreateType.EMAIL]: "Email",
  [MfaFactorCreateType.TOTP]: "Authenticator app"
};

export const mfaFactorLabel = (factor: PersonMfaFactor): string =>
  factor.label || TYPE_LABEL[factor.type] || "Verification";

export const mfaCodePrompt = (factor: PersonMfaFactor): string => {
  switch (factor.type) {
    case MfaFactorCreateType.SMS:
      return "Enter the 6-digit code we sent to your phone.";
    case MfaFactorCreateType.EMAIL:
      return "Enter the 6-digit code we sent to your email.";
    case MfaFactorCreateType.TOTP:
      return "Enter the 6-digit code from your authenticator app.";
  }
};

export const mfaCodeFieldForFactor = (
  factor: PersonMfaFactor
): keyof Pick<
  MfaChallengeVerifyRequest,
  "smsCode" | "emailCode" | "totpCode"
> => {
  switch (factor.type) {
    case MfaFactorCreateType.SMS:
      return "smsCode";
    case MfaFactorCreateType.EMAIL:
      return "emailCode";
    case MfaFactorCreateType.TOTP:
      return "totpCode";
  }
};
